export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  VERIFY_EMAIL: '/auth/verify-email',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  ACCEPT_INVITATION: '/auth/accept-invitation',
  DASHBOARD: '/dashboard',
  DETECTIONS: '/detections',
  DETECTION_DETAIL: '/detections/:id',
  TAKEDOWNS: '/takedowns',
  TAKEDOWN_DETAIL: '/takedowns/:id',
  // --- Intelligence ---------------------------------------------------------
  // Every list shares a path prefix with its dossier, so browser-back and breadcrumbs
  // work without a container route. /intelligence is the Overview.
  //
  // Campaigns is NOT under /intelligence: it is the correlation layer, a top-level
  // destination. Kits are routable but absent from the sidebar — a tenant's own kits
  // arrive as `kit_hunter` detections; /kits is the cross-tenant corpus.
  INTELLIGENCE: '/intelligence',
  CAMPAIGNS: '/campaigns',
  CAMPAIGN_DETAIL: '/campaigns/:id',
  BOTNETS: '/botnets',
  BOTNET_DETAIL: '/botnets/:id',
  KITS: '/kits',
  KIT_DETAIL: '/kits/:id',
  ACTORS: '/actors',
  ACTOR_DETAIL: '/actors/:key',
  // Hub-era tab paths — redirect targets only, never linked to. Kept so bookmarks and
  // any missed link survive the move back to flat routes.
  LEGACY_HUB_CAMPAIGNS: '/intelligence/campaigns',
  LEGACY_HUB_BOTNETS: '/intelligence/botnets',
  LEGACY_HUB_KITS: '/intelligence/kits',
  LEGACY_HUB_KIT_SHARED_FILES: '/intelligence/kits/shared-files',
  LEGACY_HUB_ACTORS: '/intelligence/actors',
  // The standalone shared-files page folded into the kit dossier (section 08).
  LEGACY_KIT_SHARED_FILES: '/kits/shared-files',
  DMARC_REPORTS: '/dmarc/reports',
  DMARC_ANALYSIS: '/dmarc/analysis',
  DMARC_UNAUTHORIZED: '/dmarc/unauthorized',
  TRAPS: '/traps',
  HONEYPOTS: '/honeypots',
  HONEYTOKENS: '/honeytokens',
  HONEYTOKEN_CREATE: '/honeytokens/new',
  HONEYTOKEN_DETAIL: '/traps/honeytokens/:id',
  HONEYTOKEN_ANALYTICS: '/traps/honeytokens/:id/analytics',
  HONEYTOKEN_TRIGGERS: '/traps/honeytokens/:id/triggers',
  USERS: '/users',
  USER_DETAIL: '/users/:id',
  COMPANY_SETTINGS: '/company/settings',
  COMPANY_SSO: '/company/sso',
  COMPANY_SCIM: '/company/scim',
  COMPANY_INTEGRATIONS: '/company/integrations',
  COMPANY_API_CREDENTIALS: '/company/api-credentials',
  COMPANY_DOMAINS: '/company/domains',
  PROFILE: '/profile',
  SECURITY_SESSIONS: '/security/sessions',
  SECURITY_MFA: '/security/mfa',
  SECURITY_PASSWORD: '/security/password',
  PROFILE_API_CREDENTIALS: '/profile/api-credentials',
  SETTINGS_GDPR: '/settings/privacy',
  COMPANY_GDPR_SETTINGS: '/company/gdpr',
  ONBOARDING: '/onboarding',
  // Premium Services
  SERVICES: '/services',
  SERVICES_BOOKINGS: '/services/bookings',
  SERVICES_BOOKING_DETAIL: '/services/bookings/:id',

  // Admin Interface (Platform Admin only)
  ADMIN: '/admin',
  ADMIN_COMPANIES: '/admin/companies',
  ADMIN_COMPANY_DETAIL: '/admin/companies/:id',
  ADMIN_COMPANY_CREATE: '/admin/companies/create',
  ADMIN_COMPANY_BATCH: '/admin/companies/batch',
  ADMIN_COMPANY_USERS: '/admin/companies/:id/users',
  ADMIN_BOOKINGS: '/admin/bookings',
  ADMIN_BOOKING_DETAIL: '/admin/bookings/:id',
  ADMIN_SERVICES: '/admin/services',
  ADMIN_SERVICE_CREATE: '/admin/services/create',
  ADMIN_SERVICE_DETAIL: '/admin/services/:id',
  ADMIN_AUDIT_LOGS: '/admin/audit-logs',
  ADMIN_QUOTES: '/admin/quotes',
} as const;

export const API_PATHS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    PASSWORD_CHANGE: '/auth/password/change',
    PASSWORD_RESET: '/auth/password/reset',
    PASSWORD_RESET_CONFIRM: '/auth/password/reset/confirm',
  },
  DASHBOARD: '/dashboard/stats',
  DETECTIONS: '/detections',
  TAKEDOWNS: '/takedowns',
  CAMPAIGNS: '/campaigns',
  DMARC: {
    REPORTS: '/reports',
    ANALYSIS: '/analysis',
    UNAUTHORIZED: '/unauthorized-sources',
  },
  USERS: '/users',
  COMPANIES: '/companies',
  HEALTH: '/health',
} as const;

export const DETECTION_STATUSES = ['Active', 'TakenDown', 'FalsePositive', 'UnderReview'] as const;
export const TAKEDOWN_STATUSES = ['Initiated', 'Submitted', 'Acknowledged', 'Resolved', 'Failed'] as const;
export const USER_ROLES = ['admin', 'analyst', 'viewer'] as const;
export const SUBSCRIPTION_TIERS = ['Free', 'Pro', 'Enterprise'] as const;
